import { fexGet } from "@/utils/fex"


// page Id defaulted for testing purposes mainly
export const getCurrentColors = async (pageId="641c30d51be9dff0797bca76")=>{
    const res = await fexGet("api/colors/page-colors/"+pageId)
    return res
}